import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { useEffect, useState } from "react";
import { baseurladdress } from "../baseurl";
import moment from "moment";

import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from 'jquery';

function Dailyshift() {
  const accessuserid = localStorage.getItem("id");
  const accesstoken = localStorage.getItem("token");
  const Swal = require("sweetalert2");
  const navigate = useNavigate();
  const location = useLocation();
  // const moment = require("moment");

  const [data, setData] = useState([]);

  function Deptpostings(staff_id) {
    navigate("/editshiftassignment/" + staff_id);
  }
  // get all  details

  useEffect(() => {
    const GetAllShiftAssignment = () => {
      axios
        .get(baseurladdress + `findallshiftassign`, {
          headers: { Authorization: `Bearer ${accesstoken}` },
        })
        .then((res) => {
          const datas = res.data.response;
          console.log("assign", datas);
          var fromDateFormatted = "";
          var toDateFormatted = "";
          const assign = datas.map((item, index) => {
            if (item.assing_fromdate && item.assign_todate) {
              fromDateFormatted = moment(item.assing_fromdate).format(
                "DD-MM-YYYY"
              );
              toDateFormatted = moment(item.assign_todate).format("DD-MM-YYYY");
            } else {
              fromDateFormatted = "";
              toDateFormatted = "";
            }
            return (
              <tr
                id={"chk" + item.staff_id}
                key={item.staff_id}
              >
                <td>{index + 1}</td>
                <td>{item.assign_staffcode}</td>
                <td>{item.assign_staffname}</td>
                <td>{item.assign_branchname}</td>
                <td>{item.assign_deptname}</td>
                <td>{item.asign_shiftname}</td>
                <td>{fromDateFormatted}</td>
                <td>{toDateFormatted}</td>
                <td>
                  {item.assign_status === 1 ? (
                    <span className="badge bg-success">Active</span>
                  ) : (
                    <span className="badge bg-danger">Inactive</span>
                  )}
                </td>
                <td style={{ textAlign: "center" }}>
                  <a className="inline-block" href="#">
                    <i
                      className="text-primary fa fa-edit"
                      onClick={() => Deptpostings(item.assign_staffid)}
                    ></i>
                  </a>
                </td>
              </tr>
            );
          });

          setData(assign);
        })
        .catch((error) => {
          alert(error);
        });
    };

    GetAllShiftAssignment();
  }, []);

  function AddShift(){
    navigate('/Addshift');
  }

  $(function () {
    setTimeout(function () {
      $('#shiftassignlist').DataTable();
    }, 1000);
  });

  return (
    <div class="card-body">
      <div class="tab-content">
        <div id="user">
          <div className="col-lg-12">
            <div className="d-flex justify-content-end mt-2">
              <button
                type="button"
                className="btn plus-icon d-flex align-items-center"
                style={{ marginRight: "50px" }} 
                onClick={() => AddShift()}
              >
                <span style={{ fontSize: "1.2rem" }}>
                  <i className="fa fa-plus-circle text-success"></i>
                </span>
                <span
                  style={{ fontSize: "0.7rem", color: "black", padding: "5px" }}
                >
                  {" "}
                  ADD
                </span>
              </button>
            </div>

            <div className="card">
              <div className="card-body">
                <div className="table-responsive">
                  <table
                    className="table table-bordered table-responsive-sm mt-2"
                    id="shiftassignlist"
                  >
                    <thead>
                      <tr>
                        <th>Sl.No</th>
                        <th>Staff Code</th>
                        <th>Staff Name</th>
                        <th>Branch</th>
                        <th>Dept Name</th>
                        <th>Shift Type</th>
                        <th>From Date</th>
                        <th>To Date</th>
                        <th>Shift Status</th>
                        <th style={{ textAlign: "center" }}>Edit</th>
                      </tr>
                    </thead>
                    <tbody>{data}</tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dailyshift;
